import * as pckg from '../../package.json';
import {getBuildVersion} from './runtimeVars';

const gitVersion = getBuildVersion();
const packageVersion = pckg.version;
const testing = import.meta.env.NODE_ENV === 'test';

// When defining REACT_APP_BUILD_VERSION in conjunction with jest
// snapshot tests of TopBar will break.
// fixme: Remove TopBar snapshot tests
export const buildVersion = testing ? '0.1.12' : gitVersion ?? packageVersion;
